import { AVENDI_HOTEL_CONFIG } from "../configs/hotel.config";
import { getValue } from "../utils/object";

export const getAvendiLocalUrl = ({ env, hotelName, roomNumber }) => {
  const hotelAddress = getValue(AVENDI_HOTEL_CONFIG[hotelName], "address", "");
  if (env === "production") {
    return `https://avendi.me/kathmandu/en?address=${hotelAddress}&room=${roomNumber}&utm_source=hotel(${hotelName})&utm_medium=popup&utm_campaign=avendi-local-hotel-traffic&utm_content=${hotelName}`;
  } else if (env === "staging") {
    return `https://demo.avendi.me/kathmandu/en?address=${hotelAddress}&room=${roomNumber}`;
  }
  return `http://localhost:3001/kathmandu/en?address=${hotelAddress}&room=${roomNumber}`;
};
